import type { Collection } from '@/services/db/collection/entity';

export function getCollectionAnalyticsProperties(collection: Collection) {
  return {
    'Collection ID': collection.id,
    'Collection Size': collection.rows,
  };
}
